<template>
  <VPanel class="relative p-6 overflow-hidden">
    <div class="flex justify-between">
      <h1 class="text-lg">مدیریت سوالات نظرسنجی</h1>

      <a href="#" @click.prevent="modalQuestion = true; editQuestion = {}"
         class="flex items-center border border-dark-line rounded-lg px-4 py-3 hover:bg-accent">
        <PlusIcon class="ml-2"/>
        سوال جدید
      </a>
    </div>
    <hr class="border-dark-line mt-6">

    <table class="w-full text-right mt-4">
      <thead>
      <tr class="text-sm text-muted">
        <th class="p-4">ردیف</th>
        <th>سوال</th>
        <th>وضعیت</th>
        <th>عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(question, index) in questions"
          :key="question.id">
        <td class="p-8">{{ index + 1 }}</td>
        <td>{{ question.question }}</td>
        <td>
          <VBadge :type="question.active ? 'success' : 'danger'">
            {{ question.active ? 'فعال' : 'غیرفعال' }}
          </VBadge>
        </td>
        <td>
          <div class="flex gap-x-2">
            <a href="#" @click.prevent="editQuestion = question; modalQuestion = true">
              <PenIcon class="text-orange"/>
            </a>
            <a href="#" @click.prevent="deleteIndex = index; modalDelete = true">
              <TrashcanIcon class="text-red"/>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <ModalSurveyQuestion
        :show="modalQuestion"
        :question="editQuestion"
        @click="modalQuestion = !modalQuestion"
        @created="questionCreated"
        @edited="questionEdited"/>

    <ModalConfirm
        title="حذف"
        text="از حذف سوال مطمئن هستید ؟"
        :show="modalDelete"
        @click="modalDelete = !modalDelete"
        @confirmed="deleteQuestion"
        @rejected="modalDelete = false"
    />

  </VPanel>
</template>

<script>
import {deleteSurveyQuestion, getSurveyQuestions} from "@/API/API";
import VPanel from "@/components/VPanel";
import PlusIcon from "@/components/Icons/PlusIcon";
import VBadge from "@/components/General/VBadge";
import PenIcon from "@/components/Icons/PenIcon";
import ModalSurveyQuestion from "@/components/Modal/ModalSurveyQuestion.vue";
import TrashcanIcon from "@/components/Icons/TrashcanIcon.vue";
import ModalConfirm from "@/components/Modal/ModalConfirm.vue";

export default {
  name: "SurveyQuestionView",
  components: {ModalConfirm, TrashcanIcon, ModalSurveyQuestion, PenIcon, VBadge, PlusIcon, VPanel},
  data() {
    return {
      questions: [],
      loading: true,

      modalQuestion: false,
      modalDelete: false,

      editQuestion: {},
      deleteIndex: '',
    }
  },
  async created() {
    this.questions = (await getSurveyQuestions()).data
    this.loading = false
  },
  methods: {
    deleteQuestion() {
      deleteSurveyQuestion(this.questions[this.deleteIndex].id)
          .then(() => {
            this.modalDelete = false
            this.questions.splice(this.deleteIndex, 1)
          })
    },
    questionCreated(question) {
      this.modalQuestion = false
      this.questions.unshift(question)
    },
    questionEdited(question) {
      this.modalQuestion = false
      let index = this.questions.findIndex(item => item.id === question.id)
      this.questions[index] = question
    }
  }
}
</script>

<style scoped>

</style>